/* eslint no-prototype-builtins: "off" */

'use strict';

const RequestHandler = require('./../../../core/requestHandler');
const baseType = 'about';

module.exports.getInformation = function() {
  let dfd;
  let currentApiUrl = RequestHandler.getBaseUrl();

  RequestHandler.setBaseUrl('/api');
  dfd = RequestHandler.read(baseType + '/information');
  RequestHandler.setBaseUrl(currentApiUrl);

  return dfd;
};
